import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled, GamificationTheme } from '../../../themeConstants'
import Constants from 'expo-constants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
    },
    containerImage: {
        flex: 1,
        width: '100%',
    },
    userImage: {
        width: 70,
        height: 70,
        borderWidth: 5.0,
        borderRadius: 35,
        borderColor: GamificationTheme.userImageBorderColor,
    },
    infoHeader: {
        flexDirection: 'row',
        width: width,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 15,
        position: 'absolute',
        zIndex: 1,
    },
    backButtonContainer: { flexDirection: 'row', alignItems: 'center' },
    rankingButtonContainer: { flexDirection: 'row', alignItems: 'center' },
    arrow: {
        marginHorizontal: 0,
    },
    playGame: {
        fontWeight: '900',
        color: GamificationTheme.gamePendingGradientBackgroundColor,
        fontSize: 18,
    },
    gameLevel: {
        fontSize: 16,
        fontWeight: 'bold',
        color: GamificationTheme.gamePendingLevelTextColor,
        marginHorizontal: 20,
        marginVertical: 10,
    },
    ranking: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
    },
    scoreBox: {
        borderRadius: 35,
        height: 60,
        backgroundColor: GamificationTheme.gamePendingGradientBackgroundColor,
    },
})

export default styles
